// client/src/coms/views/canvas_parts/canvas_room_view_parts/toolState.js
import {
  MAX_ZOOM,
  MIN_ZOOM,
  TOOL_OPACITY_DEFAULT,
  TOOL_OPACITY_MIN,
  TOOLBAR_OPEN_KEY,
} from './constants';

export function readInitialToolsOpen() {
  if (typeof window === 'undefined') return false;
  try {
    const raw = window.localStorage.getItem(TOOLBAR_OPEN_KEY);
    if (raw === 'true') return true;
    if (raw === 'false') return false;
  } catch {}
  return false;
}

export function clampZoom(value) {
  const n = Number(value);
  if (!Number.isFinite(n)) return 1;
  if (n < MIN_ZOOM) return MIN_ZOOM;
  if (n > MAX_ZOOM) return MAX_ZOOM;
  return Math.round(n * 10000) / 10000;
}

export function clampOpacity(value) {
  const n = Number(value);
  if (!Number.isFinite(n)) return TOOL_OPACITY_DEFAULT;
  if (n < TOOL_OPACITY_MIN) return TOOL_OPACITY_MIN;
  if (n > 1) return 1;
  return Math.round(n * 100) / 100;
}

export function clampSoftness(value) {
  const n = Number(value);
  if (!Number.isFinite(n)) return 0;
  if (n < 0) return 0;
  if (n > 100) return 100;
  return Math.round(n);
}

export function createToolOpacityState(overrides = {}) {
  return {
    pen: TOOL_OPACITY_DEFAULT,
    paint: TOOL_OPACITY_DEFAULT,
    pencil: TOOL_OPACITY_DEFAULT,
    calligraphy: TOOL_OPACITY_DEFAULT,
    airbrush: TOOL_OPACITY_DEFAULT,
    jitter_blob: TOOL_OPACITY_DEFAULT,
    eraser: TOOL_OPACITY_DEFAULT,
    bucket: TOOL_OPACITY_DEFAULT,
    line: TOOL_OPACITY_DEFAULT,
    rectangle: TOOL_OPACITY_DEFAULT,
    ellipse: TOOL_OPACITY_DEFAULT,
    smudge: TOOL_OPACITY_DEFAULT,
    liquify: 0.55,
    marquee_rect: TOOL_OPACITY_DEFAULT,
    marquee_ellipse: TOOL_OPACITY_DEFAULT,
    marquee_polygon: TOOL_OPACITY_DEFAULT,
    marquee_polygon_edit: TOOL_OPACITY_DEFAULT,
    grab: TOOL_OPACITY_DEFAULT,
    move: TOOL_OPACITY_DEFAULT,
    ...overrides,
  };
}

export function clampUnit(value) {
  const n = Number(value);
  if (!Number.isFinite(n)) return 0;
  if (n <= 0) return 0;
  if (n >= 1) return 1;
  return n;
}
